require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/source-map-loader!./~/angular/index.js
// module id = 43
// module chunks = 0